@if (isLoading()) {
  <div class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else {
  @for (table of tables(); track table.cropField.id) {
    <div class="growth-stage-table">
      <div class="table-title spacing--margin-half-bottom">
        <b>{{ 'cropField' | translate }}</b> {{ table.cropField.name }}
      </div>
      @if (table.rows.length === 0) {
        <p class="no-data">{{ 'downyMildew.growthStageHistory.noData' | translate }}</p>
      } @else {
        <table mat-table [dataSource]="table.rows" class="table-wrapper" data-test="growth-stage-history-table">
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{ 'downyMildew.growthStageHistory.date' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.registrationDate | date: 'shortDate' : 'UTC' : locale }}</td>
          </ng-container>

          <ng-container matColumnDef="growthStage">
            <th mat-header-cell *matHeaderCellDef>{{ 'downyMildew.growthStageHistory.growthStage' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.majorStageCode }}: {{ row.majorStageKey | translate }}</td>
          </ng-container>

          <ng-container matColumnDef="subphase">
            <th mat-header-cell *matHeaderCellDef>{{ 'downyMildew.growthStageHistory.subphase' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.subphaseCode }}: {{ row.subphaseKey | translate }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-icon-button
                type="button"
                (click)="onRemoveRegistration(row)"
                [attr.aria-label]="'downyMildew.growthStageHistory.remove' | translate"
                data-test="growth-stage-remove"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
      }
    </div>
  }
}
